"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _part = _interopRequireDefault(require("../utils/part"));

var _andToQuery = _interopRequireDefault(require("./andToQuery"));

var b = function b(fieldName, values) {
  var v1 = !values[0] ? undefined : (0, _part.default)(fieldName, {
    $gte: values[0]
  });
  var v2 = !values[1] ? undefined : (0, _part.default)(fieldName, {
    $lt: values[1]
  });
  return v1 && v2 ? (0, _andToQuery.default)([v1, v2]) : v1 || v2;
};
/**
 * Vraci query part pro interval cisel.
 *
 * 1. Pokud jsou zadanu obe hodnotu hleda se v intervalu n1 <= X < n2.
 * 2. Pokud je zadan poze datum od, hleda se vse novejsi od zadaneho datumu.
 * 2. Pokud je zadan poze datum do, hleda se vse starsi zadanemu datumu.
 *
 * @param {string} fieldName
 * @param {Array<Date>} values
 */


var betweenNumbersToQuery = function betweenNumbersToQuery(fieldName, values) {
  return !Array.isArray(values) || values.length < 1 || values[0] === undefined && values[1] === undefined ? undefined : b(fieldName, values);
};

var _default = betweenNumbersToQuery;
exports.default = _default;